/* Frostfold theme (built on the Emberkeep house layout): gallery, set picker, floating add-to-cart pill, cart drawer (Ajax Cart API), Inside-the-layers pins,
   animated accordions, sticky header. Ported from the static prototype (Stores/Fireproof Document Bag/index.html).
   No libraries. With reduced motion every animation is off and the gallery doesn't advance on its own. */
(function () {
  "use strict";

  var $ = function (s, el) { return (el || document).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  function readJSON(id) { var el = document.getElementById(id); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  var calm = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);

  var CFG = readJSON("ek-config") || {};
  var T = CFG.t || {};
  var ROUTES = CFG.routes || { root: "/", cart: "/cart", add: "/cart/add", change: "/cart/change", checkout: "/checkout" };
  var FREE_FROM = CFG.freeFrom || 2, SINGLE = CFG.singleCents || 0;
  // Locale strings arrive with [name] placeholders (see ek-config in layout/theme.liquid).
  function fill(s, o) { return String(s || "").replace(/\[(\w+)\]/g, function (m, k) { return o[k] != null ? o[k] : m; }); }

  /* ------------------------------------------------------------------ money (Shopify money format, amounts in cents) */
  function fmtNum(cents, dec, thou, point) {
    var n = (cents / 100).toFixed(dec), parts = n.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return parts.join(point);
  }
  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var f = CFG.moneyFormat || "${{amount}}";
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case "amount_no_decimals": return fmtNum(cents, 0, ",", ".");
        case "amount_with_comma_separator": return fmtNum(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return fmtNum(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator": return fmtNum(cents, 2, "'", ".");
        default: return fmtNum(cents, 2, ",", ".");
      }
    }).replace(/<[^>]*>/g, "");
  }

  var ICON = {
    pause: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6v12M15 6v12" stroke-width="2.2"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 5.5l10 6.5-10 6.5z" fill="currentColor"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6.5h11v9.5H3zM14 9.5h4l3 3.5v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/></svg>'
  };

  /* ------------------------------------------------------------------ variant data */
  var VMAP = {};            // variant id -> {id, product, title, price, compare, bags, available, image}
  function addVariants(list) { (list || []).forEach(function (v) { VMAP[v.id] = v; }); }
  addVariants(CFG.variants);
  var P = null;             // this page's product: {variants, notes}
  var state = { v: null };
  var shipFree = function (bags) { return bags >= FREE_FROM; };
  var perBag = function (v) { return Math.round(v.price / v.bags); };
  var isSale = function (v) { return v.compare > v.price; };
  function firstFree() { return P ? P.variants.filter(function (w) { return shipFree(w.bags); })[0] : null; }

  var oneVariant = function () { return !!(P && P.variants.length === 1); };
  function priceSub(v) {
    if (oneVariant()) return T.singleSub || "";
    if (shipFree(v.bags)) return fill(T.setFor, { title: v.title, price: money(v.price) });
    var w = firstFree();
    return w ? fill(T.orFor, { n: w.bags, price: money(w.price) }) : "";
  }
  function setNote(v) {
    var i = P.variants.indexOf(v), note = (P.notes || [])[i] || "";
    return (isSale(v) ? "<b>" + esc(T.youSave) + " " + money(v.compare - v.price) + "</b> " + esc(T.vsRegular) + "<br>" : "") + esc(note);
  }
  function underLine(v) { return shipFree(v.bags) ? T.underFree : fill(T.underPaid, { price: money(SINGLE), n: FREE_FROM }); }

  function updateSetUI() {
    var v = state.v; if (!v) return;
    var el;
    if ((el = $("#ek-price-now"))) el.textContent = money(perBag(v));
    if ((el = $("#ek-was"))) { el.hidden = !isSale(v); $("#ek-was-amt").textContent = money(Math.round(v.compare / v.bags)); }
    if ((el = $("#ek-launch"))) el.hidden = !isSale(v);
    if ((el = $("#ek-price-sub"))) el.textContent = priceSub(v);
    if ((el = $("#ek-bnote"))) el.innerHTML = setNote(v);
    if ((el = $("#ek-under"))) el.textContent = underLine(v);
    if ((el = $("#ek-add"))) { el.disabled = !v.available; el.textContent = !v.available ? T.soldOut : oneVariant() ? fill(T.addSingle, { price: money(v.price) }) : fill(T.add, { title: v.title, price: money(v.price) }); }
    $$('#ek-product-form input[name="id"]').forEach(function (r) { r.checked = Number(r.value) === v.id; });
    // the floating pill
    var name = $("#ek-sticky-name"); if (!name) return;
    name.innerHTML = esc(v.title) + " · " + money(v.price) + (isSale(v) ? ' <s class="ek-pill-was"><span class="ek-sr">' + esc(T.regular) + " </span>" + money(v.compare) + "</s>" : "");
    $("#ek-sticky-sub").textContent = shipFree(v.bags) ? T.freeShipping : fill(T.pillPaid, { price: money(SINGLE) });
    var shown = $("#ek-sticky").classList.contains("show");
    var seg = $("#ek-pill-seg"); seg.hidden = oneVariant();
    seg.innerHTML = oneVariant() ? "" : P.variants.map(function (w) {
      return '<button type="button" role="radio" data-pill-set="' + w.id + '" aria-checked="' + (w.id === v.id) + '" aria-label="' + esc(w.title) + ", " + money(w.price) + '" tabindex="' + (shown ? 0 : -1) + '"' + (w.available ? "" : " disabled") + ">" + w.bags + "</button>";
    }).join("");
    var add = $("#ek-sticky-add");
    add.setAttribute("aria-label", fill(T.addAria, { title: v.title, price: money(v.price) }));
    add.disabled = !v.available;
    var th = $("#ek-sticky-thumb");
    if (v.image) {
      var im = $("img", th);
      if (!im) { th.innerHTML = '<img class="ek-pic" alt="" loading="lazy" decoding="async">'; im = $("img", th); }
      if (im.getAttribute("src") !== v.image) im.setAttribute("src", v.image);
      th.hidden = false;
    } else th.hidden = true;
  }
  function selectVariant(id) { var v = VMAP[id]; if (v && P && P.variants.indexOf(v) >= 0) { state.v = v; updateSetUI(); } }
  // Left-align the price only when it wraps below the title (the theme right-aligns it beside the title).
  function initTitleWrap() {
    var row = $(".ek-title-row");
    if (!row || row._ek) return;
    row._ek = true;
    var stack = row.firstElementChild, pb = $(".ek-price-box", row);
    if (!stack || !pb) return;
    var fit = function () { row.classList.toggle("is-wrapped", pb.offsetTop > stack.offsetTop + 4); };
    fit();
    window.addEventListener("resize", fit);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }

  function initProduct() {
    P = readJSON("ek-product-json");
    if (!P || !P.variants || !P.variants.length) { P = null; return; }
    // Use the same objects in the map so indexOf works.
    P.variants = P.variants.map(function (v) { VMAP[v.id] = v; return v; });
    var checked = $('#ek-product-form input[name="id"]:checked');
    state.v = (checked && VMAP[checked.value]) || P.variants[0];
    var form = $("#ek-product-form");
    if (form && !form._ek) {
      form._ek = true;
      form.addEventListener("submit", function (e) { e.preventDefault(); if (state.v) addVariant(state.v.id, $("#ek-add")); });
    }
    updateSetUI();
  }

  /* ------------------------------------------------------------------ gallery: auto-advancing, swipeable, pausable */
  var G = { i: 0, n: 0, holdT: null };
  var motionOn = !calm;
  function setMotion(on) {
    motionOn = on;
    document.documentElement.classList.toggle("ek-still", !on);
    $$("[data-motion]").forEach(function (b) { b.innerHTML = on ? ICON.pause : ICON.play; b.setAttribute("aria-label", on ? T.pause || "Pause moving images" : T.play || "Play moving images"); });
  }
  function setSlide(i) {
    G.i = i;
    $$(".ek-seg").forEach(function (s, k) {
      s.classList.remove("on"); s.classList.toggle("done", k < i);
      if (k === i) { void s.offsetWidth; s.classList.add("on"); }
    });
    $$(".ek-thumb").forEach(function (t, k) { t.setAttribute("aria-current", String(k === i)); });
    thumbIntoView(i);
    // a video that scrolls out of view stops
    $$(".ek-slide video").forEach(function (vd, k) { if (!vd.paused && vd.closest(".ek-slide") !== $$(".ek-slide")[i]) vd.pause(); });
  }
  function thumbIntoView(i) {
    var rail = $("#ek-thumbs"), t = $$(".ek-thumb")[i];
    if (!rail || !t) return;
    var pad = 36, left = t.offsetLeft, right = left + t.offsetWidth, to = null;
    if (left - pad < rail.scrollLeft) to = left - pad;
    else if (right + pad > rail.scrollLeft + rail.clientWidth) to = right + pad - rail.clientWidth;
    if (to !== null) rail.scrollTo({ left: Math.max(0, to), behavior: calm ? "auto" : "smooth" });
  }
  function railCheck() {
    var box = $("#ek-rail"), rail = $("#ek-thumbs");
    if (!box || !rail) return;
    var l = rail.scrollLeft > 2, r = rail.scrollLeft + rail.clientWidth < rail.scrollWidth - 2;
    box.classList.toggle("can-l", l); box.classList.toggle("can-r", r);
    $(".ek-rail-btn.prev", box).hidden = !l; $(".ek-rail-btn.next", box).hidden = !r;
  }
  function goSlide(i) {
    var tr = $("#ek-track"); if (!tr || !G.n) return;
    i = (i + G.n) % G.n;
    tr.scrollTo({ left: i * tr.clientWidth, behavior: calm ? "auto" : "smooth" });
    setSlide(i);
  }
  function holdGallery(ms) {
    var g = $("#ek-gal"); if (!g) return;
    g.classList.add("held"); clearTimeout(G.holdT);
    if (ms) G.holdT = setTimeout(function () { g.classList.remove("held"); }, ms);
  }
  function initGallery() {
    var gal = $("#ek-gal"), tr = $("#ek-track"), stage = $("#ek-stage");
    if (!gal || gal._ek) return;
    gal._ek = true;
    G.n = $$(".ek-slide", tr).length; G.i = 0;
    if (G.n < 2) { var pl = $("#ek-play"); if (pl) pl.hidden = true; $$(".ek-segs", gal).forEach(function (s) { s.hidden = true; }); }
    setMotion(motionOn && G.n > 1);
    gal.addEventListener("animationend", function (e) { if (e.animationName === "ek-fill" && e.target.closest(".ek-seg.on")) goSlide(G.i + 1); });
    var t = null;
    tr.addEventListener("scroll", function () {
      clearTimeout(t);
      t = setTimeout(function () { var i = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); if (i !== G.i && i < G.n) setSlide(i); }, 110);
    }, { passive: true });
    stage.addEventListener("pointerenter", function (e) { if (e.pointerType === "mouse") holdGallery(); });
    stage.addEventListener("pointerleave", function (e) { if (e.pointerType === "mouse") gal.classList.remove("held"); });
    tr.addEventListener("touchstart", function () { holdGallery(); }, { passive: true });
    tr.addEventListener("touchend", function () { holdGallery(7000); }, { passive: true });
    gal.addEventListener("focusin", function () { holdGallery(); });
    gal.addEventListener("focusout", function () { holdGallery(4000); });
    // a playing product video holds the gallery until it ends or pauses
    $$("video", tr).forEach(function (vd) {
      vd.addEventListener("play", function () { holdGallery(); });
      vd.addEventListener("pause", function () { holdGallery(4000); });
    });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (en) { gal.classList.toggle("off", !en[0].isIntersecting); }, { threshold: .25 }).observe(stage);
    $("#ek-thumbs").addEventListener("scroll", railCheck, { passive: true });
    railCheck();
    // images load after first paint; re-check the rail once they have
    window.addEventListener("load", railCheck);
  }

  /* ------------------------------------------------------------------ inside the layers */
  function setPin(n) {
    n = n ? String(n) : "";
    $$("[data-pin]").forEach(function (el) {
      var on = el.getAttribute("data-pin") === n;
      el.classList.toggle("on", on);
      if (el.hasAttribute("aria-pressed")) el.setAttribute("aria-pressed", String(on));
    });
    var fig = $("#ek-lyr-fig"); if (fig) fig.classList.toggle("has-on", !!n);
  }
  // Pins fade in one by one the first time the picture scrolls into view (never with reduced motion; visible at rest).
  function initLayers() {
    var fig = $("#ek-lyr-fig");
    if (!fig || fig._ek || calm || !("IntersectionObserver" in window)) return;
    fig._ek = true;
    if (fig.getBoundingClientRect().top < window.innerHeight) return;   // already on screen: leave the pins as they are
    fig.classList.add("ek-wait");
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return;
      io.disconnect();
      fig.classList.remove("ek-wait"); fig.classList.add("ek-in");
      setTimeout(function () { fig.classList.remove("ek-in"); }, 2200);
    }, { threshold: .3 });
    io.observe(fig);
  }

  /* ------------------------------------------------------------------ flame-test video: autoplay muted, unless reduced motion */
  function initFireVideo() {
    $$("[data-ek-autoplay] video").forEach(function (vd) {
      if (vd._ek) return; vd._ek = true;
      vd.muted = true; vd.loop = true; vd.setAttribute("playsinline", "");
      if (calm) return;
      var go = function () { var p = vd.play(); if (p && p.catch) p.catch(function () {}); };
      if ("IntersectionObserver" in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) go(); else vd.pause(); }, { threshold: .25 }).observe(vd);
      else go();
    });
  }

  /* ------------------------------------------------------------------ what fits inside: pause the strip off screen and in a hidden tab
     (hover and keyboard focus pause it in CSS; reduced motion turns it off in CSS) */
  function marqueeSync(m) { m.classList.toggle("is-paused", !!(document.hidden || m._off)); }
  function initMarquee() {
    $$("[data-ek-marquee]").forEach(function (m) {
      if (m._ek) return; m._ek = true;
      if ("IntersectionObserver" in window) new IntersectionObserver(function (en) { m._off = !en[0].isIntersecting; marqueeSync(m); }).observe(m);
      marqueeSync(m);
    });
  }
  document.addEventListener("visibilitychange", function () { $$("[data-ek-marquee]").forEach(marqueeSync); });

  /* ------------------------------------------------------------------ sticky header + floating pill */
  var stickyCheck = null, stickyRaf = 0;
  function initSticky() {
    var btn = $("#ek-add"), bar = $("#ek-sticky"), foot = $(".ek-foot");
    if (!bar) { stickyCheck = null; return; }
    var set = function (on) { bar.classList.toggle("show", on); bar.setAttribute("aria-hidden", String(!on)); $$("#ek-sticky button").forEach(function (b) { b.tabIndex = on ? 0 : -1; }); document.body.classList.toggle("ek-sticky-on", on); };
    if (!btn) { stickyCheck = null; set(false); return; }
    stickyCheck = function () {
      var on = btn.getBoundingClientRect().bottom < 0 && !(foot && foot.getBoundingClientRect().top < window.innerHeight);
      if (on !== bar.classList.contains("show")) set(on);
    };
    set(false); stickyCheck();
  }
  function headCheck() { var hd = $("#ek-head"); if (hd) hd.classList.toggle("ek-scrolled", window.scrollY > 0 && hd.getBoundingClientRect().top <= 1); }
  function queueSticky() { if (stickyRaf) return; stickyRaf = requestAnimationFrame(function () { stickyRaf = 0; headCheck(); if (stickyCheck) stickyCheck(); }); }
  window.addEventListener("scroll", queueSticky, { passive: true });
  window.addEventListener("resize", function () { queueSticky(); railCheck(); });

  /* ------------------------------------------------------------------ cart (Ajax Cart API) */
  var cart = readJSON("ek-cart-json") || { items: [], item_count: 0, total_price: 0 };
  var lastFocus = null;
  function reveal(el) { el.hidden = false; void el.offsetWidth; el.classList.add("show"); }
  function conceal(el) {
    el.classList.remove("show");
    var done = false, end = function () { if (done) return; done = true; if (!el.classList.contains("show")) el.hidden = true; };
    el.addEventListener("transitionend", end, { once: true });
    setTimeout(end, 460);
  }
  function api(url, body) {
    return fetch(url, {
      method: body ? "POST" : "GET",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function fetchCart() { return api(ROUTES.cart + ".js").then(function (c) { cart = c; renderCart(); return c; }); }
  function bagsOf(item) {
    var v = VMAP[item.variant_id]; if (v) return v.bags;
    var src = item.variant_title || "", m = /(\d+)/.exec(src);
    return m ? Math.max(1, parseInt(m[1], 10)) : 1;
  }
  function optionValue(item, name) {
    var o = (item.options_with_values || []).filter(function (x) { return String(x.name).toLowerCase() === name; })[0];
    return o ? o.value : null;
  }
  function sized(url, w) { if (!url) return ""; return url + (url.indexOf("?") < 0 ? "?" : "&") + "width=" + w; }
  function glyph() {
    return '<svg viewBox="0 0 26 26" fill="none" aria-hidden="true"><path d="M4.4 17.6 6.7 8.7a2.2 2.2 0 0 1 2.1-1.6h8.4a2.2 2.2 0 0 1 2.1 1.6l2.3 8.9a1.7 1.7 0 0 1-1.6 2.1H6a1.7 1.7 0 0 1-1.6-2.1z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';
  }
  function renderCart() {
    var items = cart.items || [];
    var badge = $("#ek-count");
    if (badge) { badge.hidden = !cart.item_count; badge.textContent = cart.item_count; }
    var linesEl = $("#ek-lines"), foot = $("#ek-drawer-foot"), ship = $("#ek-shipline");
    if (!linesEl) return;
    var bags = items.reduce(function (a, it) { return a + bagsOf(it) * it.quantity; }, 0);
    var shipAmt = items.length && !shipFree(bags) ? SINGLE : 0, sub = cart.total_price || 0, total = sub + shipAmt;
    ship.hidden = !items.length;
    var short = FREE_FROM - bags;
    ship.innerHTML = ICON.truck + "<span>" + esc(shipFree(bags) ? T.shipFree : short === 1 ? T.shipMoreOne : fill(T.shipMoreMany, { n: short })) + "</span>";
    if (!items.length) {
      linesEl.innerHTML = '<div class="ek-empty"><p style="margin:0">' + esc(T.empty) + '</p><a class="ek-btn ek-btn-buy" href="' + esc(ROUTES.root) + '" data-close-bag>' + esc(T.seeBag) + "</a></div>";
      foot.innerHTML = ""; foot.hidden = true; return;
    }
    foot.hidden = false;
    var single = null;
    var html = items.map(function (it) {
      var v = VMAP[it.variant_id], n = bagsOf(it);
      var label = (v && v.title) || optionValue(it, "bundle") || it.variant_title || "";
      if (v && n === 1 && it.quantity === 1 && !single) single = { item: it, v: v };
      var save = v && v.compare > v.price ? (v.compare - v.price) * it.quantity : 0;
      var media = it.image ? '<img class="ek-pic" src="' + esc(sized(it.image, 144)) + '" alt="" loading="lazy">' : glyph();
      var meta = [label, n > 1 ? money(Math.round(it.final_price / n)) + " " + T.each : ""].filter(Boolean).map(esc).join(" · ");
      return '<div class="ek-line"><div class="ek-line-media">' + media + '</div><div><div class="ek-line-name">' + esc(it.product_title) + '</div><div class="ek-line-meta">' + meta + "</div>" +
        (save > 0 ? '<div class="ek-line-save">' + esc(fill(T.save, { amount: money(save) })) + "</div>" : "") +
        '<div style="display:flex;align-items:center;flex-wrap:wrap"><div class="ek-stepper" role="group" aria-label="' + esc(T.qty) + '"><button type="button" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity - 1) + '" aria-label="' + esc(T.less) + '">−</button><output aria-live="polite">' + it.quantity + '</output><button type="button" data-qty="' + esc(it.key) + '" data-to="' + (it.quantity + 1) + '" aria-label="' + esc(T.more) + '">+</button></div>' +
        '<button type="button" class="ek-remove" data-qty="' + esc(it.key) + '" data-to="0">' + esc(T.remove) + '</button></div></div><div class="ek-line-price">' + money(it.final_line_price) +
        (save > 0 ? '<s class="ek-bwas"><span class="ek-sr">' + esc(T.regular) + " </span>" + money(v.compare * it.quantity) + "</s>" : "") + "</div></div>";
    }).join("");
    // One single bag in the cart: offer the 2-bag set.
    if (single && bags === 1) {
      var two = Object.keys(VMAP).map(function (k) { return VMAP[k]; }).filter(function (w) { return w.product === single.v.product && w.bags === 2 && w.available; })[0];
      if (two) {
        var saved = single.v.price * 2 - two.price;
        html += '<div class="ek-upsell"><span><b>' + esc(fill(T.upsell, { amount: money(two.price - single.v.price) })) + "</b>" +
          esc(fill(!shipFree(bags) && shipFree(2) ? T.upsellFree : T.upsellSave, { amount: money(saved) })) +
          '</span><button type="button" class="ek-btn ek-btn-buy" data-upgrade="' + esc(single.item.key) + '" data-to-variant="' + two.id + '">' + esc(T.upgrade) + "</button></div>";
      }
    }
    linesEl.innerHTML = html;
    foot.innerHTML = '<div class="ek-sumrow"><span>' + esc(T.subtotal) + "</span><span>" + money(sub) + "</span></div>" +
      '<div class="ek-sumrow"><span>' + esc(T.shipping) + "</span><span>" + (shipAmt ? money(shipAmt) : esc(T.free)) + "</span></div>" +
      '<div class="ek-subrow"><span>' + esc(T.total) + "</span><span>" + money(total) + "</span></div>" +
      '<p class="ek-fine">' + esc(fill(T.fine, { days: CFG.returnsDays || 30 })) + "</p>" +
      '<a class="ek-btn ek-btn-buy" id="ek-checkout" href="' + esc(ROUTES.checkout) + '" style="width:100%">' + esc(fill(T.checkout, { total: money(total) })) + "</a>";
    var payTpl = document.getElementById("ek-pay-tpl");
    if (payTpl && payTpl.content) foot.appendChild(payTpl.content.cloneNode(true));
  }
  function busy(on, btn) { var d = $("#ek-drawer"); if (d) d.classList.toggle("busy", on); if (btn) btn.classList.toggle("busy", on); }
  var toastT = null;
  function toast(msg) { var t = $("#ek-toast"); if (!t) return; t.textContent = msg; t.classList.add("show"); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove("show"); }, 3000); }
  function fail(err) { toast((err && (err.description || err.message)) || T.error); }
  function addVariant(id, btn) {
    busy(true, btn);
    return api(ROUTES.add + ".js", { items: [{ id: Number(id), quantity: 1 }] })
      .then(fetchCart)
      .then(function () { if ($("#ek-drawer").hidden) openCart(); })
      .catch(fail)
      .then(function () { busy(false, btn); });
  }
  function changeLine(key, qty) {
    busy(true);
    return api(ROUTES.change + ".js", { id: key, quantity: qty })
      .then(function (c) { cart = c; renderCart(); })
      .catch(fail)
      .then(function () { busy(false); });
  }
  function upgrade(key, toId) {
    busy(true);
    return api(ROUTES.change + ".js", { id: key, quantity: 0 })
      .then(function () { return api(ROUTES.add + ".js", { items: [{ id: Number(toId), quantity: 1 }] }); })
      .then(fetchCart)
      .then(function () { toast(T.upgraded); var c = $("#ek-bag-close"); if (c) c.focus(); })
      .catch(function (e) { fail(e); fetchCart(); })
      .then(function () { busy(false); });
  }
  function openCart() { var d = $("#ek-drawer"); if (!d) return; lastFocus = document.activeElement; reveal($("#ek-scrim")); reveal(d); $("#ek-bag-close").focus(); }
  function closeCart() { conceal($("#ek-scrim")); conceal($("#ek-drawer")); if (lastFocus && lastFocus.focus) lastFocus.focus(); }

  /* ------------------------------------------------------------------ events (bound once, on the document) */
  document.addEventListener("click", function (e) {
    var t = e.target.closest("button, a");
    if (!t) return;
    if (t.hasAttribute("data-pin")) { setPin(t.getAttribute("data-pin")); return; }
    if (t.hasAttribute("data-pill-set")) { selectVariant(Number(t.getAttribute("data-pill-set"))); var nb = $('[data-pill-set="' + t.getAttribute("data-pill-set") + '"]'); if (nb) nb.focus(); return; }
    if (t.hasAttribute("data-rail")) { var rl = $("#ek-thumbs"); rl.scrollBy({ left: Number(t.getAttribute("data-rail")) * rl.clientWidth * .8, behavior: calm ? "auto" : "smooth" }); return; }
    if (t.hasAttribute("data-slide")) { goSlide(Number(t.getAttribute("data-slide"))); holdGallery(8000); return; }
    if (t.hasAttribute("data-motion")) { setMotion(!motionOn); return; }
    if (t.hasAttribute("data-upgrade")) { upgrade(t.getAttribute("data-upgrade"), t.getAttribute("data-to-variant")); return; }
    if (t.hasAttribute("data-qty")) { changeLine(t.getAttribute("data-qty"), Math.max(0, Number(t.getAttribute("data-to")))); return; }
    if (t.hasAttribute("data-close-bag")) { if (P) { e.preventDefault(); closeCart(); } return; }
    switch (t.id) {
      case "ek-sticky-add": if (state.v) addVariant(state.v.id, t); break;
      case "ek-bag-btn": e.preventDefault(); renderCart(); openCart(); fetchCart().catch(function () {}); break;
      case "ek-bag-close": closeCart(); break;
    }
  });
  document.addEventListener("change", function (e) {
    if (e.target.name === "id" && e.target.closest("#ek-product-form")) selectVariant(Number(e.target.value));
  });
  document.addEventListener("keydown", function (e) {
    var d = $("#ek-drawer"), open = d && !d.hidden;
    if (e.key === "Escape") { if (open) closeCart(); return; }
    if (e.key === "Tab" && open) {
      var f = $$("#ek-drawer button:not([disabled]), #ek-drawer a[href]");
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.addEventListener("mouseover", function (e) { var t = e.target.closest && e.target.closest("button[data-pin]"); if (t) setPin(t.getAttribute("data-pin")); });
  document.addEventListener("focusin", function (e) { var t = e.target.closest && e.target.closest("button[data-pin]"); if (t) setPin(t.getAttribute("data-pin")); });
  ["mouseout", "focusout"].forEach(function (ev) {
    document.addEventListener(ev, function (e) { var g = e.target.closest && e.target.closest("#ek-lyr-grid"); if (g && !g.contains(e.relatedTarget)) setPin(null); });
  });
  document.addEventListener("visibilitychange", function () { var g = $("#ek-gal"); if (g) g.classList.toggle("off", document.hidden); queueSticky(); });

  // Every <details> opens and closes with a height animation instead of snapping; padding collapses too.
  document.addEventListener("click", function (e) {
    var sum = e.target.closest("details > summary");
    if (!sum || calm) return;
    var d = sum.parentNode, body = sum.nextElementSibling;
    if (!body || !body.animate) return;
    e.preventDefault();
    if (d._anim) { d._anim.cancel(); clearTimeout(d._t); }
    var ease = "cubic-bezier(.2,.7,.2,1)", cs;
    var shut = { height: "0px", paddingTop: "0px", paddingBottom: "0px", opacity: 0 };
    var closing = d.open && !d.classList.contains("closing");
    if (!closing) { d.classList.remove("closing"); d.open = true; }
    cs = getComputedStyle(body);
    var full = { height: body.offsetHeight + "px", paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom, opacity: 1 };
    var ms = closing ? 260 : 320, settled = false;
    if (closing) d.classList.add("closing");
    body.style.overflow = "hidden";
    var settle = function () { if (settled) return; settled = true; if (closing) { d.open = false; d.classList.remove("closing"); } body.style.overflow = ""; d._anim = null; };
    d._anim = body.animate(closing ? [full, shut] : [shut, full], { duration: ms, easing: ease });
    d._anim.onfinish = settle;
    d._t = setTimeout(settle, ms + 60);
  });

  // Back/forward cache: the cart may have changed on another page.
  window.addEventListener("pageshow", function (e) { if (e.persisted) fetchCart().catch(function () {}); });

  /* ------------------------------------------------------------------ start, and restart when the theme editor reloads a section */
  function init() {
    initProduct();
    initTitleWrap();
    initGallery();
    initLayers();
    initFireVideo();
    initMarquee();
    initSticky();
    headCheck();
    renderCart();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
